import React, { useState } from "react";
import { formatPhoneNumber } from "../../../../../utils/utils";
import styles from "./index.module.scss";
import DropdownC from "../../../../../stories/common/dropdown";
import {
  CallButtonClicked,
  EmailButtonClicked
} from "../../../../../utils/inv-exch-amplitude";
import { useSearchParams } from "react-router-dom";

export default function ContactWeb({ account }: { account: any }) {
  const [contact, setContact] = useState<any>(account?.contacts?.[0] ?? null);
  const [searchParams] = useSearchParams();
  const pubPropertyId = searchParams.get("pid") ?? account?.propertyId;
  const pubPropertySfid = searchParams.get("sfid") ?? account?.propertySfid;

  return (
    <>
      {account?.contacts?.length > 0 ? (
        <>
          {account?.contacts?.length > 1 ? (
            <DropdownC
              showClear={false}
              placeholder="Select Contact"
              className={styles.dropdownBox}
              options={account?.contacts}
              optionLabel="name"
              panelClassName={styles.dropdownList}
              onChange={(e: any) => setContact(e.value)}
              value={contact}
            />
          ) : (
            <div className={styles.singleContact}>{contact?.name}</div>
          )}
          <div
            className={styles.email}
            onClick={(e) => {
              e.stopPropagation();
              window.location.href = `mailto:${contact.email}`;
              EmailButtonClicked({
                property_id: pubPropertyId,
                property_sfid: pubPropertySfid,
                investor_sfid: account?.acctSfid,
                investor_id: account?.acctId,
                contact: {
                  ...contact
                }
              });
            }}
          >
            {contact?.email}
          </div>
          <div
            className={styles.email}
            onClick={(e) => {
              e.stopPropagation();
              window.location.href = `tel:${contact.mobile}`;
              CallButtonClicked({
                property_id: pubPropertyId,
                property_sfid: pubPropertySfid,
                investor_sfid: account?.acctSfid,
                investor_id: account?.acctId,
                contact: {
                  ...contact
                }
              });
            }}
          >
            {contact?.mobile && formatPhoneNumber(contact?.mobile)}
          </div>
        </>
      ) : (
        <div className={styles.singleContact}>No Contacts</div>
      )}
    </>
  );
}
